/**
 * AI-generated code, moderated by lzygmanski
 */
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';

export type AmbulancePrintMedicalConditionsProps = {
  conditions: string[];
};

const AmbulancePrintMedicalConditions = ({
  conditions,
}: AmbulancePrintMedicalConditionsProps) => {
  const {t} = useTranslation();

  if (!conditions || conditions.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="h2" asChild className="text-lg font-semibold">
        <h2>{t('Medical condition')}</h2>
      </Typography>
      <ul className="list-inside list-disc space-y-1">
        {conditions.map((condition, idx) => (
          <li key={idx} className="print:break-inside-avoid">
            <Typography asChild className="inline">
              <span>{condition}</span>
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AmbulancePrintMedicalConditions;
